<style>
.calendly-overlay iframe {
    display: inline;
    width: 100% !important;
    height: 100% !important;
}
@media screen and (max-width: 800px) {
.ftco-section {
    padding: 0em 0 2em 0;
    position: relative;
}

._3efP_GeH5kyBAzqnLzL._kN_bCa3VNYpqFLH311L {
    max-width: 680px;
}
}
</style>

<template>
  <div id="classes-view">
    <head>
      <link href="https://assets.calendly.com/assets/external/widget.css" rel="stylesheet">
      <meta name="description" content="Support for breastfeeding, pumping. Join our expert-led classes and support groups for guidance and connection">
    </head>
    <section class="bg-light ftco-section">
      <div class="conatiner">
        <div class="text-center">
          <h3 class="sub-h2  text-center">
            support
          </h3>
          <h1 class="mb-4 display-4 text-center">
            Classes, Support Groups<br>
          </h1>
          <img src="@/assets/site/images/icons/2.svg" class="img-fluid my-3" alt />
          <h2>Breastfeeding Support Group</h2>
        </div>
        <div class="container">
          <p class="resources-text">Bringing a new life into the word is amazing but not everything with that comes
            easily and no new parent
            should feel alone in the journey. This group is facilitated by our Jodie Lactation Consultant. Get support, meet other moms and get the help you need from our
            Lactation Consultant.</p><br>
          <img src="@/assets/site/images/flower-3.webp" alt class="img-fluid classes-flower" />
          <p class="resources-text mb-3">
            Topics and Support include breastfeeding, latching, pumping, return to work, sleep and well being
          </p>
          <h2 class="mb-3">Breastfeeding Class</h2>
          <p class="resources-text">This class covers everything breastfeeding, from getting off to a great start, pumping and back to work,
            nursing in the first hours and days through year(s) of life. This class is offered by Jodie our
            Lactation Consultant. This is a great class for expectant
            parents to take to prepare for the most important part of caring for the newborn, Breastfeeding. Jodie
            provides evidence based information and has had years of experience working with birth and breastfeeding.
          </p> 
        </div>
      </div>
    </section>
    <div class="conatiner-fluid d-flex justify-content-center">
      <img src="@/assets/site/images/classes-img.png" class="img-fluid" alt="">
    </div>
    <section>
      <div class="container">
        <h1 class="text-black display-4 text-center my-5">
          Classes & Consults
        </h1>
        <div class="row  my-5">
          <div class="col-md-5">
            <img src="@/assets/site/images/edn-1.png" alt class="img-fluid" />
          </div>
          <div class="col-md-7">
            <h3 class="mt-5 mb-2 text-light1">Breast Feeding Classes</h3>
            <div class="row mb-4">
              <div class="col">
                <span class="text3">
                  <img src="@/assets/site/images/zoom.svg" alt /> Zoom Supported
                </span>
              </div>
              <div class="col">
                <span class="text3">
                  <img src="@/assets/site/images/person.svg" alt /> In Person Limited
                </span>
              </div>
            </div>
            <p>
              This class is offered by Jodie our Lactation Consultant and Registered
              Nurse. This is a great class for expectant parents to take to prepare for the most important part of
              caring for the newborn, Breastfeeding. Jodie provides evidence based information and has had years of
              experience working with birth and breastfeeding. This class covers everything breastfeeding, from
              getting off to a great start, pumping and back to work, nursing in the first hours and days through
              year(s) of life...
            </p>
            <button id="calendly-button-class-1" class="btn btn-light my-2 col-md-8">Schedule</button>
          </div>
        </div>

      
    
        <div class="row my-5">
          <div class="col-md-5">
            <img src="@/assets/site/images/edn-3.png" alt class="img-fluid" />
            <img src="@/assets/site/images/path-1.webp" alt class="img-fluid"
              style="position: absolute; width: 70%; right: 70%; top: -20%;" />
          </div>
          <div class="col-md-7">
            <h3 class="mt-5 mb-2 text-light1">Breastfeeding Support Group</h3>
            <div class="row mb-4">
              <div class="col">
                <span class="text3">
                  <img src="@/assets/site/images/zoom.svg" alt /> Zoom Supported
                </span>
              </div>
              <div class="col">
                <span class="text3">
                  <img src="@/assets/site/images/person.svg" alt /> In Person Limited
                </span>
              </div>
            </div>
            <p>
              Bringing a new life into the word is amazing but not everything with that comes easily and no new parent
              should feel alone in the journey. This group is facilitated by Jodie (IBCLC, RN). Get support, meet other
              moms and get the help you need from our Lactation Consultant...
            </p>
            <button id="calendly-button-class-2" class="btn btn-light my-2 col-md-8">Schedule</button>
          </div>
        </div>
      </div>
      <div class="resources-text text-center pb-3">
              <p style="font-size: 0.7em; line-height: 1.2;">This information is to be used at the discretion of the individual and is not a substitute for medical advice. 
                Please contact your lactation consultant or primary care provider for medical advice. This list of resources was put together by Jodie Dresel RN, IBCLC. </p>
            </div>
      <div class="row text-center">
       
      </div>
    
    </section>
  </div>
</template>


<script>
export default {
  mounted() {
    // Dynamically load Calendly widget script
    const calendlyScript = document.createElement('script');
    calendlyScript.src = "https://assets.calendly.com/assets/external/widget.js";
    calendlyScript.async = true;
    document.head.appendChild(calendlyScript);

    // Add event listener for each button after the script is loaded
    calendlyScript.onload = () => {
      // Infant Feeding and Pumping Classes
      document.getElementById('calendly-button-class-1').addEventListener('click', function() {
        Calendly.initPopupWidget({
          url: 'https://calendly.com/jodie/infant-feeding-and-pumping-classes'
        });
        return false;
      });

      // Infant Feeding and Pumping Support Group
      document.getElementById('calendly-button-class-2').addEventListener('click', function() {
        Calendly.initPopupWidget({
          url: 'https://calendly.com/jodie/infant-feeding-and-pumping-support-group'
        });
        return false;
      });

    };
  }
};
</script>